:host {
  @apply block;
}

::slotted(vds-slides[slot=media]) {
  @apply w-full h-full;
}

::slotted(vds-slides[slot=content]) {
  @apply min-w-full min-h-full flex items-center justify-center bg-white;
}

img.separator {
  @apply h-full max-h-[411px] block absolute top-0 bottom-0 z-20 translate-x-[-1px] select-none;

  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
